import { raisedSurface as e } from "../../theme/theme.mjs";
import t from "react";
import { styled as n } from "styled-components";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/Widget/Widget.tsx
var a = n.div`
    ${e};
    color: ${({ theme: e }) => e.colors.cardForeground};
    padding: ${({ theme: e }) => e.spacing(2)};
    transition: box-shadow ${({ theme: e }) => e.transitions.normal};
    display: flex;
    flex-direction: column;
`, o = n.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1.5)};
`, s = n.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${({ theme: e }) => e.radii.lg};
    background-color: ${({ theme: e }) => e.colors.secondary};
    color: ${({ theme: e }) => e.colors.primary};
    flex-shrink: 0;

    svg {
        width: 20px;
        height: 20px;
    }
`, c = n.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    min-width: 0;
`, l = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:first-child {
        margin-left: 8px;
    }
`, u = n.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
`, d = n.div`
    flex: 1;
    margin-top: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(2)};
    background: ${({ theme: e }) => e.colors.card};
    border-radius: ${({ theme: e }) => e.radii.xl};
`, f = n.div`
    margin-top: ${({ theme: e }) => e.spacing(2)};
    padding-top: ${({ theme: e }) => e.spacing(2)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
`, p = ({ title: e, icon: t, action: n, className: a }) => /* @__PURE__ */ i(o, {
	className: a,
	children: [/* @__PURE__ */ i(c, { children: [t && /* @__PURE__ */ r(s, { children: t }), /* @__PURE__ */ r(l, { children: e })] }), n && /* @__PURE__ */ r(u, { children: n })]
}), m = ({ children: e, className: t }) => /* @__PURE__ */ r(d, {
	className: t,
	children: e
}), h = ({ children: e, className: t }) => /* @__PURE__ */ r(f, {
	className: t,
	children: e
}), g = t.forwardRef(({ children: e, className: t, ...n }, i) => /* @__PURE__ */ r(a, {
	ref: i,
	className: t,
	...n,
	children: e
}));
g.displayName = "Widget";
var _ = g;
_.Header = p, _.Content = m, _.Footer = h;
//#endregion
export { _ as Widget };
